import React, { createContext, useState } from 'react'
import { getScreeningSectionsFromDb } from 'src/mentor/components/ScreeningReportMakingPage/util'

export const ScreeningSectionsContext = createContext()

export default function ScreeningSectionsProvider({ children }) {
  const [screeningSections, setScreeningSections] = useState([])

  /**
   * Fetch screening sections based on mentor data
   * @param {Object} mentorData - Mentor profile data
   * @returns {Promise<Array>} Screening sections
   */
  const getScreeningSections = async ({ specializedCategories, visitType }) => {
    try {
      const sections = await getScreeningSectionsFromDb({
        doctorSpecializations: specializedCategories,
        visitType: visitType,
      })
      setScreeningSections(sections)
      return sections
    } catch (error) {
      console.error('Error fetching screening sections:', error)
      return []
    }
  }

  return (
    <ScreeningSectionsContext.Provider
      value={{ screeningSections, setScreeningSections, getScreeningSections }}
    >
      {children}
    </ScreeningSectionsContext.Provider>
  )
}
